import { ref } from 'vue'

export interface ConfirmOptions {
  message: string
  title?: string
  confirmLabel?: string
  cancelLabel?: string
  destructive?: boolean
}

interface PendingConfirmation {
  options: ConfirmOptions
  resolve: (confirmed: boolean) => void
}

export const currentConfirmation = ref<PendingConfirmation | null>(null)
const queue: PendingConfirmation[] = []

export function confirm(options: ConfirmOptions | string) {
  return new Promise<boolean>((resolve) => {
    const pending = {
      options: typeof options === 'string' ? { message: options } : options,
      resolve,
    }

    if (currentConfirmation.value) {
      queue.push(pending)
    } else {
      currentConfirmation.value = pending
    }
  })
}

export function resolveConfirmation(confirmed: boolean) {
  const pending = currentConfirmation.value

  if (!pending) {
    return
  }

  pending.resolve(confirmed)
  currentConfirmation.value = queue.shift() ?? null
}
